import { render, staticRenderFns } from "./AutoPostBoostingErrors.vue?vue&type=template&id=39b97596&"
import script from "./AutoPostBoostingErrors.vue?vue&type=script&lang=ts&"
export * from "./AutoPostBoostingErrors.vue?vue&type=script&lang=ts&"
import style0 from "./AutoPostBoostingErrors.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports